<template>
  <div>
    <Summary :isLoadingSummary="isLoadingSummary" :summaryData="summaryData" />
    <h3>Mandatory Trainings</h3>
    <HorizontalCardGrid
      :selectedItems="selectedItems"
      :isCanSelect="true"
      :forceSelect="true"
      :activeTab="activeTab"
      :isLoading="isLoadingTNA"
      :items="mandatoryTrainings"
      :type="'mandatory_trainings'"
      @open-detail="handleOpenModalDetail"
      @select-change="$emit('select-change', ...arguments)"
    />
    <h3>Gap Competencies</h3>
    <HorizontalCardGrid
      :selectedItems="selectedItems"
      :activeTab="activeTab"
      :isLoading="isLoadingTNA"
      :items="gapCompetencies"
      :type="'gap_competencies'"
      :isFooter="false"
      @open-detail="handleOpenModalDetail"
      @select-change="$emit('select-change', ...arguments)"
    />
    <DetailTNA
      :isLoadingModal="isLoadingModal"
      :showDetailModal="showDetailModal"
      :selectedTNA="dataModal"
      @close="() => $emit('close-detail')"
    />
    <DetailTNACompetency
      :isLoadingModal="isLoadingModal"
      :showDetailModalCompetency="showDetailModalCompetency"
      :listCompetencies="dataModalCompetency"
      :selectedItems="selectedItems"
      @close="() => $emit('close-detail')"
      :handleOpenModalDetail="handleOpenModalDetail"
      @select-change="$emit('select-change', ...arguments)"
    />
  </div>
</template>

<script>
import HorizontalCardGrid from "./horizontal-card-grid.vue";
import Summary from "./summary.vue";
import DetailTNA from "../modal/DetailTNA.vue";
import DetailTNACompetency from "../modal/DetailTNACompetency.vue";

export default {
  name: "Structured",
  emits: ["close-detail", "select-change"],
  components: { Summary, HorizontalCardGrid, DetailTNA, DetailTNACompetency },

  props: {
    activeTab: String,
    selectedItems: Array,
    isLoadingSummary: Boolean,
    isLoadingTNA: Boolean,
    isLoadingModal: Boolean,
    summaryData: Object,
    mandatoryTrainings: Array,
    gapCompetencies: Array,
    handleOpenModalDetail: Function,
    showDetailModal: Boolean,
    showDetailModalCompetency: Boolean,
    dataModal: {
      type: Object,
      default: () => null,
    },
    dataModalCompetency: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
